import { MoreHoriz } from '@mui/icons-material'
import { MenuItem, Select, Typography, Box, Button } from '@mui/material'
import Modal from 'components/molecules/Modal/Modal'
import { LoadingButton } from 'components/mui'
import styles from './EditTrayCategoryModal.module.scss'

export interface EditTrayCategoryModalProps {
  open: boolean
  onClose: () => void
  onConfirm: (category: string) => void
  selectedCategory: string
  setSelectedCategory: (cat: string) => void
  isUpdating: boolean
  trayCategoryOptions: { value: string; label: string }[]
}

const EditTrayCategoryModal = ({
  open,
  onClose,
  onConfirm,
  selectedCategory,
  setSelectedCategory,
  isUpdating,
  trayCategoryOptions,
}: EditTrayCategoryModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div className={styles.editTrayCategoryModal_organism}>
        <div className={styles.headerBox}>
          <MoreHoriz />
          <Typography variant="h3">Modify Tray Category</Typography>
        </div>
        <Select
          fullWidth
          variant="outlined"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value as string)}
          displayEmpty
          renderValue={(selected) => {
            if (!selected) {
              return (
                <Typography variant="body1" color="gray">
                  Select Tray Category
                </Typography>
              )
            }
            const found = trayCategoryOptions.find(
              (opt) => opt.value === selected
            )
            return found ? found.label : selected
          }}
        >
          {trayCategoryOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
        <Box display="flex" gap={2} width="100%" justifyContent="flex-end">
          <Button onClick={onClose} disabled={isUpdating}>
            Cancel
          </Button>
          <LoadingButton
            disabled={!selectedCategory || isUpdating}
            onClick={() => onConfirm(selectedCategory)}
            loading={isUpdating}
          >
            {isUpdating ? 'Saving...' : 'Confirm Category Selection'}
          </LoadingButton>
        </Box>
      </div>
    </Modal>
  )
}

export default EditTrayCategoryModal
